import { useState, useEffect } from 'react'
import { auth } from '../firebase/config'
import { useAuthContext } from './useAuthContext'
import { signInWithEmailAndPassword } from 'firebase/auth'


export const useLogin = () => {
  const [isCancelled, setIsCancelled] = useState(false)
  const [error, setError] = useState(null)
  const [isPending, setIsPending] = useState(false)
  const { dispatch } = useAuthContext()

  const login = async (email, password) => {
    setError(null)
    setIsPending(true)

    // sign out user
    try {
      const res = await signInWithEmailAndPassword(auth, email, password)
      
      // dispatch login action
      dispatch({ type: 'LOGIN', payload: res.user })
      // dispatch set custom claims action
      const idTokenResult = await res.user.getIdTokenResult() 
      dispatch({ type: 'SET_CUSTOM_CLAIMS', payload: idTokenResult.claims })

      // update state
      if (!isCancelled) {
        setIsPending(false)
        setError(null)
      }            
    } catch (err) {
      if (!isCancelled) {
        console.log(err.message)
        setError(err.message)
        setIsPending(false)
      }
    }
  }

  useEffect(() => {
    return () => setIsCancelled(true)
  }, [])

  return { login, error, isPending }
}